import styled from 'styled-components'
import media from 'styled-media-query'

export const FloatingButton = styled.div`
    font-family: ${props => props.theme.font};
    font-size: 14px;
    width:100%;
    height:60px;
    position: fixed;
    bottom: 0;
    background-color: ${props => props.theme.header.floatingButtonBg};
    color: ${props => props.theme.header.floatingButtonText};
    text-align:center;
    box-shadow: 2px 2px 3px #999;
    cursor: pointer;
    line-height: 4;
    transition: bottom 0.3s;
    display: none;

    &.show {
        bottom: -65px;
    }

    ${media.lessThan('medium')`
        z-index: 11;
        display: block;
    `}
`
